import { createContext, PropsWithChildren, useContext } from "react";

const FilterableItemContext = createContext<unknown>(undefined);

interface FilterableItemProviderProps {
    item: unknown;
}

export const FilterableItemProvider = ({
    item,
    children
}: PropsWithChildren<FilterableItemProviderProps>) => (
    <FilterableItemContext.Provider value={item}>
        {children}
    </FilterableItemContext.Provider>
);

/** Reads the current per-iteration item. Returns undefined outside an iteration. */
export const useFilterableItem = (): unknown =>
    useContext(FilterableItemContext);
